import { useState } from 'react';
import { P2GBadge, P2GBox, P2GGrid, P2GIcon, P2GLink, SvgCaretDown, SvgCaretRight } from '@parcel2go/core-ui';
import { FilterItem, SmartSendFilter, SmartSendFilterContext } from '../../../lib/helpers/SmartSendFilterApplier';
import FilterOptionsGrid from './FilterOptionsGrid';

interface props {
  filter: SmartSendFilterContext;
  update: (filter: SmartSendFilter) => void;
  selected: FilterItem;
  open?: boolean;
}

export default function FilterItemView(props: props) {
  const openAsDefault = !!props.open;
  const [open, setOpen] = useState(openAsDefault);
  const f = props.selected;
  const selection = props.filter.CurrentFilter.FilterSelections.find((x) => x.Name === f.name);
  const active = selection?.Include.length > 0 || selection?.Exclude.length > 0;

  const reset = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    props.update({
      ...props.filter.CurrentFilter,
      FilterSelections: props.filter.CurrentFilter.FilterSelections.filter((x) => x.Name !== f.name).concat({
        Name: f.name,
        Include: [],
        Exclude: []
      })
    });
    setOpen(false);
  };

  return (
    <P2GBox key={`filter_${f.name}`}>
      {openAsDefault ? (
        <P2GLink variant="body2" fontWeight="bold" colour="primary" underline="none">
          {f.label ?? f.name}
        </P2GLink>
      ) : (
        <P2GGrid container spacing={1} alignItems="center">
          <P2GGrid item flexShrink={1}>
            <P2GLink onClick={() => setOpen(!open)} variant="body2" fontWeight="bold" colour="primary" underline="none">
              {f.label ?? f.name}
            </P2GLink>
            {active && (
              <span style={{ margin: '0 15px' }}>
                <P2GBadge
                  badgeContent={selection.Include.length + selection.Exclude.length}
                  colour="primary"
                  children={undefined}
                />
              </span>
            )}
          </P2GGrid>
          {!open && active && (
            <P2GGrid item flexShrink={1}>
              <P2GLink variant="body2" onClick={reset}>
                Clear
              </P2GLink>
            </P2GGrid>
          )}
          <P2GGrid item flexGrow={1}></P2GGrid>
          <P2GGrid item flexShrink={1}>
            <P2GIcon size="xs" palette="primary" onClick={() => setOpen(!open)}>
              {open ? <SvgCaretRight /> : <SvgCaretDown />}
            </P2GIcon>
          </P2GGrid>
        </P2GGrid>
      )}
      {(open || openAsDefault) && (
        <FilterOptionsGrid
          filterItem={props.selected}
          selection={props.filter.CurrentFilter.FilterSelections.find((x) => x.Name === props.selected.name)}
          onSave={(included, excluded) => {
            props.update({
              ...props.filter.CurrentFilter,
              FilterSelections: props.filter.CurrentFilter.FilterSelections.filter(
                (x) => x.Name !== props.selected.name
              ).concat({
                Name: props.selected.name,
                Include: included,
                Exclude: excluded
              })
            });
          }}
        />
      )}
    </P2GBox>
  );
}
